import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
// import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-custom-dropdown',
  templateUrl: './custom-dropdown.component.html',
  styleUrls: ['./custom-dropdown.component.css'],
})
export class CustomDropdownComponent {
  uniqueId: string = '82375093485790238475';
  // uuidv4();

  @Input()
  dataArray: any[] | undefined = [];

  @Input() bindValue: string = '';
  @Input() bindName: string = '';
  @Input() bindIcon: string = '';
  @Input() selectedObject: any;
  @Input() translateKey: string = '';
  @Input() placeholder: string = '';
  @Input() loading: boolean = false;
  @Input() error: boolean = false;
  @Input() showAbsolute: boolean = true;

  @Output()
  optionEmitter = new EventEmitter();

  openDropdown = false;

  otherOptionKey: string = `Other_12345678`;
  showOtherOptionInput: boolean = false;

  otherOptionText: string = '';

  private isFirstChange = true;

  ngOnChanges(changes: SimpleChanges) {
    this.setLoadingStatus();
  }

  setLoadingStatus() {
    if (this.loading) {
      this.openDropdown = false;
      this.showOtherOptionInput = false;
    }
  }

  toggleDropdown() {
    if (!this.loading) {
      this.openDropdown = !this.openDropdown;
    }
  }

  selectOption(event: any) {
    this.showOtherOptionInput = false;
    this.optionEmitter.emit(event);
    this.openDropdown = false;
  }

  setOtherOptionText(text: string) {
    this.optionEmitter.emit(text);
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const targetElement = event.target as HTMLElement;

    // Verifica si el clic ocurrió dentro del dropdown usando el id único
    const element = document.getElementById(`${this.uniqueId}`);

    if (element && !element.contains(targetElement)) {
      this.openDropdown = false;
    }
  }
}
